<template>
  <div ref="iroColorPicker" :style="{ width: `${width}px` }" class="color-picker-iro">
    <!-- Skeleton -->
    <div v-if="!colorPickerObject" class="color-picker-iro__skeleton">
      <div class="color-picker-iro__skeleton-inner">
        <div class="color-picker-iro__skeleton-wheel">&nbsp;</div>
        <div class="color-picker-iro__skeleton-line">&nbsp;</div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import iro from '@jaames/iro';

export default {
  name: 'color-picker',
  props: {
    width: {
      type: Number,
      default: 290,
    },
    modelValue: {
      type: Object,
    },
  },
  data() {
    return {
      colorPickerObject: null,
    };
  },
  computed: {
    rgb() {
      const { r, g, b } = this.modelValue;

      return { r, g, b };
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    emitColor(rawColorObject) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        r: Math.round(rawColorObject.rgb.r),
        g: Math.round(rawColorObject.rgb.g),
        b: Math.round(rawColorObject.rgb.b),
      });
    },
    initialize() {
      // TODO: REVIEW - why do we need nextTick here???
      this.$nextTick(() => {
        this.colorPickerObject = new iro.ColorPicker(this.$refs.iroColorPicker, {
          width: this.width - 50,
          color: this.rgb,
          layoutDirection: 'horizontal',
          layout: [
            {
              component: iro.ui.Wheel,
              options: {},
            },
            {
              component: iro.ui.Slider,
              options: { sliderMargin: 22 },
            },
          ],
        });

        this.colorPickerObject.on('color:change', this.debouncedEmitColor);
      });
    },
    updateColorPicker() {
      // The picker is built a tick after mount, and the colour can change before then — a table
      // cell's editor seeds its draft as it opens. Nothing to push yet; `initialize` reads the
      // current colour when it builds.
      if (!this.colorPickerObject) return;

      this.colorPickerObject.color.rgb = this.rgb;
    },
  },
  watch: {
    rgb() {
      this.updateColorPicker();
    },
  },
  created() {
    this.debouncedEmitColor = debounce(this.emitColor, 200, { leading: true });
  },
};
</script>

<style lang="scss">
// ============================================================================
// Color Picker Iro
.color-picker-iro {
  width: 100%;

  &__skeleton {
    width: 100%;
    padding-top: 116%;
    position: relative;
  }

  &__skeleton-inner {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  &__skeleton-inner::before,
  &__skeleton-wheel {
    width: 100%;
    height: 0;
    padding-top: 100%;
    margin-bottom: 1.2rem;
    border-radius: 100rem;
    font-size: 0;
    line-height: 0;
    background: -2px 0 / calc(100% + 0.4rem) 100% no-repeat;
    background-image: url(@assets/images/skeleton-loading-animation.gif);
    opacity: 0.15;
  }

  &__skeleton-inner::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    background: rgba(0, 0, 0, 0.04);
    opacity: 1;
  }

  &__skeleton-inner::after,
  &__skeleton-line {
    width: 100%;
    height: 3rem;
    border-radius: 10rem;
    background: -2px 0 / calc(100% + 0.4rem) 100% no-repeat;
    background-image: url(@assets/images/skeleton-loading-animation.gif);
    opacity: 0.15;
  }

  &__skeleton-inner::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    z-index: 2;
    background: rgba(0, 0, 0, 0.04);
    opacity: 1;
  }
}
</style>
